'use client';

import { Product } from 'shared/types/product/Product';
import { DataSource } from 'types/datasource';
import { TasticProps } from 'frontastic/tastics/types';
import InstantSearch from 'components/HOC/InstantSearch';
import LocalizedIndex from 'providers/algolia/localized-index';
import ProductSliderAlgolia, { ProductSliderProps } from 'components/commercetools-ui/organisms/product/product-slider-algolia';

function ProductSliderAlgoliaTastic({ data }: TasticProps<DataSource<{ items: Product[]; categoryToFetch: string; subCategoryToFetch: string; parentProductId: string }> & ProductSliderProps>) {
  //if (!data?.data?.dataSource?.items) return <p>No products found.</p>;

  //eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { mobile, tablet, desktop, ...props } = data;
  return (
    <InstantSearch>
      <LocalizedIndex type="products">
      <ProductSliderAlgolia 
        {...props} 
        categoryToFetch={data?.data?.dataSource?.categoryToFetch ?? ''}
        subCategoryToFetch={data?.data?.dataSource?.subCategoryToFetch ?? ''}
        parentProductId={data?.data?.dataSource?.parentProductId ?? ''}
        products={data?.data?.dataSource?.items ?? []} />
      </LocalizedIndex>
    </InstantSearch>
  );
}

export default ProductSliderAlgoliaTastic;
